import { Component, HostListener, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import 'moment/locale/pt-br';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';
import { CollaboratorAddress } from 'src/app/models/colaborador';
import { ColaboradorCadastro } from 'src/app/models/colaborador-cadastro';
import { CollaboratorType } from 'src/app/models/collaborator-type';
import { Departamento } from 'src/app/models/departamento';
import { EnderecoCep, EnderecoCidade } from 'src/app/models/endereco';
import { FormFields } from 'src/app/models/form-field';
import { Unidade } from 'src/app/models/unidade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { TipoSexo } from 'src/app/shared/enums/tipo-sexo.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ResponseBase } from '../../../../../models/response-base';
import { TutorialProgresso } from '../../../../../models/tutorial';
import { TutorialService } from '../../../../../services/tutorial.service';






@Component({
    selector: 'app-colaborador-create',
    templateUrl: './colaborador-create.component.html',
    styleUrls: ['./colaborador-create.component.scss']
})
export class ColaboradorCreateComponent implements OnInit {

    private progresso: TutorialProgresso;
    tipoColaborador: any;
    campoFormulario: FormFields[];
    addressReq: boolean = false;
    temContaSeuValeLog = false;

    constructor(
        private formBuilder: FormBuilder,
        private colaboradorService: ColaboradorService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private parametrosDataService: ParametrosDataService,
        private tutorialService: TutorialService,
        private addressService: EnderecoService
    ) {
        this.onResize();
        this.disableSince(new Date());
    }

    public get form() {
        return this.colaboradorFormGroup.controls;
    }

    private addressCEP: EnderecoCep;
    private enderecoCidade: EnderecoCidade[];
    emptyCity: boolean = true;
    emptyUf: boolean = true;

    public MASKS = MASKS;
    public TipoSexo = TipoSexo;
    private routeSubscription: Subscription;
    private urlReturn = null;
    public isMobile = false;
    public inDocumento: string;
    public inBirthDate: Date;
    private currentUser: Auth;
    colaboradorCadastro: ColaboradorCadastro;
    colaboradorFormGroup: FormGroup;
    isUnidadeRequired = false;
    colaboradorLimiteError = false;
    minimumAge = 18;
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';
    public labelCentroCusto = 'Centro de Custo';
    public labelUnidade = 'Unidade';
    public labelDepartamento = 'Departamento';

    public mostrarColunaAplicativo = true;
    public mostrarColunaCentroCusto = true;
    public mostrarColunaUnidade = true;
    public mostrarColunaDepartamento = true;

    public permitirEditarMatricula = true;
    public maxAge = 200;
    public permitirGerenciarCartoesBeneficio = true;

    public cadastroColaboradorEmailObrigatorio = false;
    public cadastroColaboradorTelefoneObrigatorio = true;
    public maxDate = new Date();

    public collaboratorType: CollaboratorType[];
    public documentReq = true;
    public birthDateReq = true;
    public phoneReq = true;
    public emailReq = false;
    public motherNameReq = true;
    public invalidDate = false;

    public maskDate = [/\d/, /\d/, '/', /\d/, /\d/, '/',/\d/, /\d/,/\d/, /\d/]

    public myDatePickerOptions: IAngularMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        minYear: 1901,
        maxYear: 2078,
        monthLabels: {
            1: 'Janeiro',
            2: 'Fevereiro',
            3: 'Março',
            4: 'Abril',
            5: 'Maio',
            6: 'Junho',
            7: 'Julho',
            8: 'Agosto',
            9: 'Setembro',
            10: 'Outubro',
            11: 'Novembro',
            12: 'Dezembro'
        },
        dayLabels: {
            su: 'Dom',
            mo: 'Seg',
            tu: 'Ter',
            we: 'Qua',
            th: 'Qui',
            fr: 'Sex',
            sa: 'Sáb'
        },
        stylesData: {
            selector: 'dp1',
            styles: `
              .dp1 .myDpIconLeftArrow,
              .dp1 .myDpIconRightArrow,
              .dp1 .myDpHeaderBtn {
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtn:focus,
              .dp1 .myDpMonthLabel:focus,
              .dp1 .myDpYearLabel:focus {
                 color: #aaa;
              }
              .dp1 .myDpDaycell:focus,
              .dp1 .myDpMonthcell:focus,
              .dp1 .myDpYearcell:focus {
                 box-shadow: inset 0 0 0 1px #ccc;
              }
              .dp1 .myDpSelector:focus {
                 box-shadow: -1px 1px 6px 0px #bbb;
              }
              .dp1 .myDpSelectorArrow:focus:before {
                 border-bottom-color: #bbb;
              }
              .dp1 .myDpCurrMonth,
              .dp1 .myDpMonthcell,
              .dp1 .myDpYearcell {
                 color: #6c757d;
              }
              .dp1 .myDpDaycellWeekNbr {
                 color: #6c757d;
              }
              .dp1 .myDpPrevMonth,
              .dp1 .myDpNextMonth {
                 color: #aaa;
              }
              .dp1 .myDpWeekDayTitle {
                 background-color: transparent;
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtnEnabled:hover,
              .dp1 .myDpMonthLabel:hover,
              .dp1 .myDpYearLabel:hover {
                 color: #212529;
              }
              .dp1 .myDpMarkCurrDay,
              .dp1 .myDpMarkCurrMonth,
              .dp1 .myDpMarkCurrYear {
                 border-bottom: 2px solid #6c757d;
              }
              .dp1 .myDpDisabled {
                 color: #999;
              }
              .dp1 .myDpHighlight {
                 color: #cd5c5c;
              }
              .dp1 .myDpTableSingleDay:hover,
              .dp1 .myDpTableSingleMonth:hover,
              .dp1 .myDpTableSingleYear:hover {
                 background-color: #ccc;
                 color: #222;
              }
              .dp1 .myDpRangeColor {
                 background-color: #eee;
              }
              .dp1 .myDpSelectedDay,
              .dp1 .myDpSelectedMonth,
              .dp1 .myDpSelectedYear {
                 background-color: #ccc;
                 color: #222;
              }
            `
        }
    };
    dateMask = MaskedDate;

    disableSince(d: Date) {
        d.setDate(d.getDate() + 1);
        const copy = this.getCopyOfOptions();
        copy.disableSince = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: d.getDate() - 1
        };
        this.myDatePickerOptions = copy;
        return this.myDatePickerOptions;
    }

    getCopyOfOptions() {
        return JSON.parse(JSON.stringify(this.myDatePickerOptions));
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.isUnidadeRequired = this.getUnityRequirement();
        this.routeSubscription = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });
        this.loadLists();

        this.loadViewConfig();
        this.createForm(
            new ColaboradorCadastro(
                '',
                '',
                '',
                null,
                null,
                TipoSexo.Indefinido,
                '',
                '',
                '',
                '',
                null,
                null,
                null,
                null,
                null,
                null,
                null
            )
        );
        if (!this.permitirEditarMatricula) {
            this.colaboradorFormGroup.get('matricula').disable();
        }

        this.collaboratorType = JSON.parse(localStorage.getItem('collaboratorType'));

        if (true)
            this.collaboratorType = this.collaboratorType.filter(x => x.collaboratorTypeId != 5)

        this.tipoColaborador = this.collaboratorType[0].collaboratorTypeId;
        this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
        this.tipocolaborador(this.tipoColaborador);
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.idadeMinimaColaborador]) {
                this.minimumAge = +this.parametros[ParametrosKey.idadeMinimaColaborador];
            }
            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ]
            ) {
                this.labelCentroCusto = this.parametros[
                    ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ];
            } else {
                this.labelCentroCusto = 'Centro de Custo';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaUnidadeColaborador
                ]
            ) {
                this.labelUnidade = this.parametros[
                    ParametrosKey.labelPersonalizadaUnidadeColaborador
                ];
            } else {
                this.labelUnidade = 'Unidade';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ]
            ) {
                this.labelDepartamento = this.parametros[
                    ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ];
            } else {
                this.labelDepartamento = 'Departamento';
            }

            if (
                this.parametros[
                ParametrosKey.permitirEditarMatriculaColaborador
                ]
            ) {
                this.permitirEditarMatricula = BooleanConverter.getBoolean(
                    this.parametros[
                    ParametrosKey.permitirEditarMatriculaColaborador
                    ]
                );
            } else {
                this.permitirEditarMatricula = true;
            }

            if (this.parametros[ParametrosKey.idadeMaximaColaborador]) {
                this.maxAge = +this.parametros[ParametrosKey.idadeMaximaColaborador];
            }

            // ao criar o colaborador se true redireciona para a página de cartões
            if (this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]) {
                this.permitirGerenciarCartoesBeneficio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]);
            }

            if (this.parametros[ParametrosKey.cadastroColaboradorEmailObrigatorio]) {
                this.cadastroColaboradorEmailObrigatorio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.cadastroColaboradorEmailObrigatorio]);
            }

            if (this.parametros[ParametrosKey.cadastroColaboradorTelefoneObrigatorio]) {
                this.cadastroColaboradorTelefoneObrigatorio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.cadastroColaboradorTelefoneObrigatorio]);
            }

            if (this.parametros[ParametrosKey.temContaSeuValeLog]) {
                this.temContaSeuValeLog = BooleanConverter.getBoolean(this.parametros[ParametrosKey.temContaSeuValeLog]);
            }

            if (this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores]
                )) {
                this.mostrarColunaCentroCusto = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores]
                )) {
                this.mostrarColunaUnidade = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores]
                )) {
                this.mostrarColunaDepartamento = false;
            }
        }
    }

    getUnityRequirement(): boolean {
        if (
            this.parametrosDataService.currentParametrosValue &&
            this.parametrosDataService.currentParametrosValue[
            ParametrosKey.exigirUnidadeCadastroColaborador
            ]
        ) {
            return JSON.parse(
                this.parametrosDataService.currentParametrosValue[
                ParametrosKey.exigirUnidadeCadastroColaborador
                ]
            );
        }
        return false;
    }

    loadLists() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
            });
        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
            });
        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
            });
    }

    createForm(colaboradorCadastro: ColaboradorCadastro) {
        const today = new Date();
        this.colaboradorFormGroup = this.formBuilder.group({
            email: new FormControl(colaboradorCadastro.email, [
                Validators.email
            ]),
            nome: new FormControl(colaboradorCadastro.nome, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            // sobrenome: new FormControl(colaboradorCadastro.sobrenome, [
            //     Validators.required,
            //     Validators.minLength(3),
            //     Validators.maxLength(100)
            // ]),
            documento: new FormControl(colaboradorCadastro.documento, [
               // Validators.required,
                NgBrazilValidators.cpf
            ]),
            dataNascimento: new FormControl(
                colaboradorCadastro.dataNascimento,
                [
                    //Validators.required,
                ]
            ),
            sexo: new FormControl(colaboradorCadastro.sexo, []),
            matricula: new FormControl(colaboradorCadastro.matricula, []),
            nomeMae: new FormControl(colaboradorCadastro.nomeMae, [
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            nomePai: new FormControl(colaboradorCadastro.nomePai, [
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            celular: new FormControl(colaboradorCadastro.celular, [
                GenericValidator.isCellPhone,
                NgBrazilValidators.celular
            ]),
            condutor: new FormControl(false, [
            ]),
            cnh: new FormControl(colaboradorCadastro.cnh, [
                Validators.minLength(11),
                Validators.maxLength(11)
            ]),
            cnhDataExpiracao: new FormControl(colaboradorCadastro.cnhDataExpiracao, [
                Validators.minLength(11),
                Validators.maxLength(11)
            ]),
            centroCustoId: new FormControl(
                colaboradorCadastro.centroCustoId,
                []
            ),
            unidadeId: new FormControl(colaboradorCadastro.unidadeId),
            departamentoId: new FormControl(
                colaboradorCadastro.departamentoId,
                []
            ),
            cep: new FormControl(null, [
                //Validators.maxLength(9),
                NgBrazilValidators.cep
            ]),
            address: new FormControl(null, [
                Validators.maxLength(500),
            ]),
            number: new FormControl(null, [
                Validators.maxLength(10),
            ]),
            complement: new FormControl(null, [
                Validators.maxLength(50)
            ]),
            neighborhood: new FormControl(null, [
                Validators.maxLength(200),
            ]),
            city: new FormControl(null, [
            ]),
            uf: new FormControl(null, [
            ])
        });

        if (this.isUnidadeRequired) {
            this.colaboradorFormGroup
                .get('unidadeId')
                .setValidators(Validators.required);
        }

        if (this.maxAge < 200) {
            this.colaboradorFormGroup
                .controls.dataNascimento.setValidators([
                    GenericValidator.maximumAge(this.maxAge),
                    Validators.required
                ]
                );
            this.colaboradorFormGroup.controls.dataNascimento.updateValueAndValidity();
        }

        if (this.cadastroColaboradorEmailObrigatorio) {
            this.colaboradorFormGroup.controls.email.setValidators([
                Validators.email,
                Validators.required
            ]);
            this.colaboradorFormGroup.controls.email.updateValueAndValidity();
        }

        if (this.cadastroColaboradorTelefoneObrigatorio) {
            this.colaboradorFormGroup.controls.celular.setValidators([
                Validators.required,
                GenericValidator.isCellPhone,
                NgBrazilValidators.celular
            ]);
            this.colaboradorFormGroup.controls.celular.updateValueAndValidity();
        }
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 11) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }

    goToBack() {
        this.router.navigate(['../list'], { relativeTo: this.route });
    }

    semNumero(number: any){
        if(number == null || number == '' || !+number){
            this.colaboradorFormGroup.controls.number.setValue("S/N");
        }
    }

    getAddress(cep: string) {
        if (this.colaboradorFormGroup.get('cep').valid && this.colaboradorFormGroup.get('cep').value) {
            this.addressService.getCEP(cep.replace(/\D+/g, '')).subscribe(
                response => {
                    this.addressCEP = response.result;
                    if(this.addressCEP.uf == null || this.addressCEP.cidade == null){
                        this.emptyUf = false;
                        this.emptyCity = false;
                    }
                    this.setAddress(this.addressCEP);

                }, error => {
                    this.alertService.error('CEP não localizado!');
                }
            );

        }
    }

    setAddress(enderecoCEP?: EnderecoCep) {
        if (enderecoCEP) {
            this.getCity(enderecoCEP.uf);
            this.colaboradorFormGroup.patchValue({
                address: enderecoCEP.logradouro,
                neighborhood: enderecoCEP.bairro,
                city: enderecoCEP.cidade,
                uf: enderecoCEP.uf,
                cep: enderecoCEP.cep,
                number: 'S/N'
            });
        } else {
            return;
        }

    }

    getCity(uf: string) {
        if(uf == null || uf.replace(/\s/g,'') === '')
            uf = null;

        if (uf) {
            this.addressService.getCidade(uf).subscribe(
                response => {
                    this.enderecoCidade = response.result;
                },
                error => {
                    this.alertService.error('Não foi possível carregar as cidades');
                }
            );
        }
    }

    get value(): Date {
        return this.colaboradorFormGroup.controls.dataNascimento.value;
    };

    //set accessor including call the onchange callback
    set value(v: Date) {
        if (v !== this.colaboradorFormGroup.controls.dataNascimento.value) {
            this.colaboradorFormGroup.controls.dataNascimento.setValue((v.getDate() < 10 ? '0'+v.getDate() : v.getDate())+'/'+(v.getMonth()+1 < 10 ? '0'+(v.getMonth()+1) : (v.getMonth()+1))+'/'+v.getFullYear());
        }
    }

    onChange(event) {
        this.value = event;
        this.onBlur();
    }

    onBlur() {
        //this.onChangeCallback(this.innerValue);
    }

    todate(value) {
        this.inBirthDate = this.formatDate(value);
        // this.colaboradorFormGroup.get('dataNascimento').setValue(this.formatDate(value));
    }

    formatDate(date: string) {
        const dateArray = date?.split('/');
        if (!this.isDate(date) || !dateArray || dateArray.length !== 3 || dateArray.some(x => !Number(x))) {
            this.invalidDate = true;
            this.colaboradorFormGroup.get('dataNascimento').markAsTouched();
            this.colaboradorFormGroup.get('dataNascimento').setValue('');
            return ;
        } else {
           this.invalidDate = false;
           return new Date(`${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`);
        }
    }

    isDate(data: any){
      var RegExPattern = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

      if (!((data.match(RegExPattern)) && (data!=''))) {
        return false
      } else {
        return true
      }
    }

    public CompleteWithZero() {
        if (!this.inDocumento) { return; }

        const inputValue = this.inDocumento.replace(/\D+/g, '').replace(' ', '');
        let zeros = '';

        for (let i = 0; i < 11 - inputValue.length; i++) { zeros += '0'; }

        this.inDocumento = this.formataCPF(zeros + inputValue);
    }

    formataCPF(cpf) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    onSubmit(colaboradorCadastro: ColaboradorCadastro) {
        this.colaboradorLimiteError = false;
        const dataNascimentoMemoria = colaboradorCadastro.dataNascimento;        
        /*if(colaboradorCadastro.dataNascimento)
            colaboradorCadastro.dataNascimento = this.formatDate(colaboradorCadastro.dataNascimento);*/

        /*if (colaboradorCadastro.dataNascimento) {
            if (colaboradorCadastro.dataNascimento.singleDate.date) {
                colaboradorCadastro.dataNascimento = new Date(
                    colaboradorCadastro.dataNascimento.singleDate.date.year,
                    colaboradorCadastro.dataNascimento.singleDate.date.month -
                    1,
                    colaboradorCadastro.dataNascimento.singleDate.date.day
                );
            }
        }*/

        colaboradorCadastro.celular = colaboradorCadastro.celular.replace(/\D+/g, '').replace(' ', '');

        if (this.colaboradorFormGroup.valid) {

            if(colaboradorCadastro.documento != undefined){
                colaboradorCadastro.documento = colaboradorCadastro.documento
                    .replace(/\D+/g, '')
                    .replace(' ', '');
            }
            if(colaboradorCadastro.celular != undefined){
                colaboradorCadastro.celular = colaboradorCadastro.celular
                    .replace(/\D+/g, '')
                    .replace(' ', '');
            }

            colaboradorCadastro.tipoColaborador = this.tipoColaborador;

            if(colaboradorCadastro.unidadeId != null)
                colaboradorCadastro.unidadeId = parseInt(colaboradorCadastro.unidadeId.toString());
            if(colaboradorCadastro.departamentoId != null)
                colaboradorCadastro.departamentoId = parseInt(colaboradorCadastro.departamentoId.toString());
            if(colaboradorCadastro.centroCustoId != null)
                colaboradorCadastro.centroCustoId = parseInt(colaboradorCadastro.centroCustoId.toString());

            if(this.form.cep.value){
                colaboradorCadastro.endereco = new CollaboratorAddress();
                colaboradorCadastro.endereco.cep = this.form.cep.value.replace(/\D+/g, '');
                colaboradorCadastro.endereco.address = this.form.address.value;
                colaboradorCadastro.endereco.number = this.form.number.value;
                colaboradorCadastro.endereco.complement = this.form.complement.value;
                colaboradorCadastro.endereco.neighborhood = this.form.neighborhood.value;
                colaboradorCadastro.endereco.city = this.form.city.value;
                colaboradorCadastro.endereco.uf = this.form.uf.value;
            }
            this.colaboradorService
                .add(
                    colaboradorCadastro,
                    this.currentUser.token.assignorGuid,
                    this.currentUser.token.userReferenceId
                )
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message, true);

                            sessionStorage.removeItem('currentCollaborator');
                            sessionStorage.setItem('currentCollaborator',response.result.name);

                            if (this.permitirGerenciarCartoesBeneficio) {
                                this.router.navigate([`cartao/${response.result.collaboratorId}`], { queryParams: { doc: colaboradorCadastro.documento }, relativeTo: this.route.parent });
                            } else {
                                this.router.navigate(
                                    [`list/${colaboradorCadastro.documento}`],
                                    { relativeTo: this.route.parent }
                                );
                            }
                            this.alertService.success("Favorecido cadastrado");

                            this.updateProgressoTutorial();
                        } else {
                            this.alertService.error(response.message, true);
                        }
                    },
                    error => {
                        if (
                            error.error ===
                            'Limite de favorecidos da unidade excedido'
                        ) {
                            this.colaboradorLimiteError = true;
                        }
                        console.log(error)
                        this.alertService.error(error.error, false);
                    }
                );
        } else {
            GenericValidator.verifierValidatorsForm(this.colaboradorFormGroup);
        }

        this.colaboradorFormGroup.controls.dataNascimento.setValue(dataNascimentoMemoria);
    }

    private updateProgressoTutorial() {
        this.progresso = new TutorialProgresso;
        this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {
                /* console.log(resp.result) */

                this.progresso.ativo = resp.result.ativo;
                this.progresso.ordemAtividade = (resp.result.progresso / 20);
                this.progresso.idCedente = this.currentUser.token.assignorGuid;
                this.progresso.idGestor = this.currentUser.token.userReferenceId;
                this.progresso.nomeTutorial = 'homeCedente';
                if (this.progresso.ordemAtividade === 3) {
                    this.progresso.ordemAtividade++;
                    this.tutorialService.updateProgresso(this.progresso).subscribe(r => {
                        /* console.log(r) */
                    });
                }
            }
        }, error => {
            console.log(error);
        });
    }

    tipocolaborador(v?: number, e?: any, toggle: boolean = false){
        if(!v) v = e+1;

        if(v == 1)
        {
            this.tipoColaborador = 1;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 2){
            this.tipoColaborador = 2;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 3){
            this.tipoColaborador = 3;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
        if(v == 4){
            this.tipoColaborador = 4;
            this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
            this.changeValidator(this.campoFormulario);
        }
    }

    changeConductorRequired(){
        if(this.colaboradorFormGroup.controls.condutor.value){
            this.colaboradorFormGroup.controls['cnh'].setValidators(null);
        } else {
            this.colaboradorFormGroup.controls['cnh'].setValidators(Validators.required);
        }
    }

    changeValidator(formField: any){
        this.addressReq = false;
        if(formField.find(x=>x.formFieldName == "Documento")){
            var x = formField.find(x=>x.formFieldName == "Documento")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['documento'].setValidators([Validators.required,NgBrazilValidators.cpf]);
                this.documentReq = true;
            }
            else{
                this.colaboradorFormGroup.controls['documento'].clearValidators();
                this.colaboradorFormGroup.controls['documento'].setValidators([NgBrazilValidators.cpf]);
                this.documentReq = false;
            }

            this.colaboradorFormGroup.controls.documento.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "Telefone")){
            var x = formField.find(x=>x.formFieldName == "Telefone")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['celular'].setValidators([Validators.required,
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.celular]);
                this.cadastroColaboradorTelefoneObrigatorio = true;
            }else{
                this.colaboradorFormGroup.controls['celular'].clearValidators();
                this.colaboradorFormGroup.controls['celular'].setValidators([
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.celular
                ]);
                this.cadastroColaboradorTelefoneObrigatorio = false;
            }

            this.colaboradorFormGroup.controls.celular.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "Email")){
            var x = formField.find(x=>x.formFieldName == "Email")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['email'].setValidators([Validators.required,Validators.email]);
                this.cadastroColaboradorEmailObrigatorio = true;
            }else{
                this.colaboradorFormGroup.controls['email'].clearValidators();
                this.colaboradorFormGroup.controls['email'].setValidators([Validators.email]);
                this.cadastroColaboradorEmailObrigatorio = false;
            }

            this.colaboradorFormGroup.controls.email.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "DataNascimento")){
            var x = formField.find(x=>x.formFieldName == "DataNascimento")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['dataNascimento'].setValidators([Validators.required,GenericValidator.maximumAge(this.maxAge)]);
                this.birthDateReq = true;
            }else{
                this.colaboradorFormGroup.controls['dataNascimento'].clearValidators();
                this.colaboradorFormGroup.controls['dataNascimento'].setValidators([GenericValidator.maximumAge(this.maxAge)]);
                this.birthDateReq = false;
            }

            this.colaboradorFormGroup.controls.dataNascimento.updateValueAndValidity();
        }
        if(formField.find(x=>x.formFieldName == "NomeMae")){
            var x = formField.find(x=>x.formFieldName == "NomeMae")
            if(x.isStandard){
                this.colaboradorFormGroup.controls['nomeMae'].setValidators([Validators.required,Validators.minLength(3),Validators.maxLength(100)]);
                this.motherNameReq = true;
            }else{
                this.colaboradorFormGroup.controls['nomeMae'].clearValidators();
                this.colaboradorFormGroup.controls['nomeMae'].setValidators([Validators.minLength(3),Validators.maxLength(100)]);
                this.motherNameReq = false;
            }

            this.colaboradorFormGroup.controls.nomeMae.updateValueAndValidity();
        }
        if(this.tipoColaborador === 1 || this.tipoColaborador === 2 || this.tipoColaborador === 5){
            this.addressReq = true;
            this.colaboradorFormGroup.controls['cep'].setValidators([Validators.required,NgBrazilValidators.cep]);
            this.colaboradorFormGroup.controls['address'].setValidators([Validators.required,Validators.maxLength(500)]);
            this.colaboradorFormGroup.controls['number'].setValidators([Validators.required,Validators.maxLength(10)]);
            this.colaboradorFormGroup.controls['complement'].setValidators([Validators.maxLength(50)]);
            this.colaboradorFormGroup.controls['neighborhood'].setValidators([Validators.required,Validators.maxLength(200)]);
            this.colaboradorFormGroup.controls['city'].setValidators([Validators.required]);
            this.colaboradorFormGroup.controls['uf'].setValidators([Validators.required]);
        }
        else{
            this.colaboradorFormGroup.controls['cep'].clearValidators();
            this.colaboradorFormGroup.controls['address'].clearValidators();
            this.colaboradorFormGroup.controls['number'].clearValidators();
            this.colaboradorFormGroup.controls['complement'].clearValidators();
            this.colaboradorFormGroup.controls['neighborhood'].clearValidators();
            this.colaboradorFormGroup.controls['city'].clearValidators();
            this.colaboradorFormGroup.controls['uf'].clearValidators();

            this.colaboradorFormGroup.controls['cep'].setValidators([NgBrazilValidators.cep]);
            this.colaboradorFormGroup.controls['address'].setValidators([Validators.maxLength(500)]);
            this.colaboradorFormGroup.controls['number'].setValidators([Validators.maxLength(10)]);
            this.colaboradorFormGroup.controls['complement'].setValidators([Validators.maxLength(50)]);
            this.colaboradorFormGroup.controls['neighborhood'].setValidators([Validators.maxLength(200)]);

            this.colaboradorFormGroup.controls.cep.updateValueAndValidity();
            this.colaboradorFormGroup.controls.address.updateValueAndValidity();
            this.colaboradorFormGroup.controls.number.updateValueAndValidity();
            this.colaboradorFormGroup.controls.complement.updateValueAndValidity();
            this.colaboradorFormGroup.controls.neighborhood.updateValueAndValidity();
            this.colaboradorFormGroup.controls.city.updateValueAndValidity();
            this.colaboradorFormGroup.controls.uf.updateValueAndValidity();
        }
        this.colaboradorFormGroup.markAsUntouched();
    }
}

export function MaskedDate(event: any) {
    const v = event.target.value;
    if (event.keyCode !== 8) {
        if (v.match(/^\d{2}$/) !== null) {
            event.target.value = v + '/';
        } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
            event.target.value = v + '/';
        }
    }
}
